import { ChevronLeft, ChevronRight } from 'lucide-react';
import { IconButton } from './icon-button';

type Props = {
  page: number;
  lastPage: number;
  total: number;
  from: number | null;
  to: number | null;
  onChange: (page: number) => void;
};

export function Pager({ page, lastPage, total, from, to, onChange }: Props) {
  if (lastPage <= 1) return null;

  return (
    <div className="flex items-center justify-between border-t border-[var(--color-border)] px-4 py-2 text-xs text-[var(--color-foreground-muted)]">
      <div>
        {from ?? 0}–{to ?? 0} of {total}
      </div>
      <div className="flex items-center gap-1">
        <IconButton
          onClick={() => onChange(page - 1)}
          disabled={page <= 1}
          aria-label="Previous page"
        >
          <ChevronLeft className="size-4" />
        </IconButton>
        <span className="px-2">
          Page {page} of {lastPage}
        </span>
        <IconButton
          onClick={() => onChange(page + 1)}
          disabled={page >= lastPage}
          aria-label="Next page"
        >
          <ChevronRight className="size-4" />
        </IconButton>
      </div>
    </div>
  );
}
